import type { FC } from 'react';
import {
  Box,
  Card,
  CardContent,
  Container,
  Typography,
  Avatar,
  Stack,
  Unstable_Grid2 as Grid
} from '@mui/material';

interface Partner {
  name: string;
  title: string;
  company: string;
  testimonial: string;
  avatar: string;
  metric?: {
    value: string;
    label: string;
  };
}

const partners: Partner[] = [
  {
    name: 'Vivek Madani',
    title: 'Head COE',
    company: 'Flipkart',
    testimonial: 'Partnering with SwiftRamp was a game-changer for our NFT ventures at Flipkart. Their onramp, offramp, and wallet solutions, backed by top-notch compliance, made things smooth and reliable for our users.',
    avatar: '/assets/avatars/vivek-madani-profile.png',
    metric: {
      value: '48 sec',
      label: 'Avg. Processing Time'
    }
  },
  {
    name: 'Manish Agrawal',
    title: 'Co-Founder & CEO',
    company: 'KOEN',
    testimonial: 'With SwiftRamp\'s trustworthy setup, our expansion was seamless. Their standout offering? Instant INR conversions. It\'s been such a boon, even our Indian colleagues now enjoy their pay in crypto.',
    avatar: '/assets/avatars/manish-agrawal-profile.png',
    metric: {
      value: '>98%',
      label: 'Success Rate'
    }
  },

];

export const HomeReviews: FC = () => (
  <Box
    component="section"
    sx={{
      backgroundColor: '#f5f5f7',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
      py: { xs: 8, md: 10 }
    }}
  >
    <Container maxWidth="lg">
      <Stack spacing={{ xs: 4, md: 5 }}>
        <Box sx={{ textAlign: 'center', maxWidth: '800px', mx: 'auto' }}>
          <Typography
            variant="h3"
            sx={{
              mb: 2,
              fontWeight: 700,
              position: 'relative',
              display: 'inline-block',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -8,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 60,
                height: 4,
                backgroundColor: 'primary.main',
                borderRadius: 2
              }
            }}
          >
            Trusted by our partners
          </Typography>

          <Typography
            color="text.secondary"
            variant="subtitle1"
            sx={{
              maxWidth: '600px',
              mx: 'auto',
              fontSize: '1.125rem',
              mt: 3
            }}
          >
            See what industry leaders are saying about our payment solutions
          </Typography>
        </Box>

        <Grid
          container
          spacing={4}
          justifyContent="center"
          sx={{ mt: 2 }}
        >
          {partners.map((partner, index) => (
            <Grid
              key={index}
              xs={12}
              md={6}
            >
              <Card
                sx={{
                  height: '100%',
                  backgroundColor: 'background.paper',
                  borderRadius: 3,
                  boxShadow: 'none',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.08)'
                  }
                }}
              >
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    p: { xs: 3, md: 4 }
                  }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', mb: 4 }}>
                    <Avatar
                      src={partner.avatar}
                      sx={{
                        height: 80,
                        width: 80,
                        mb: 3,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                        border: '3px solid',
                        borderColor: 'background.paper'
                      }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 3,
                        fontSize: '1rem',
                        lineHeight: 1.7,
                        fontStyle: 'italic',
                        color: 'text.secondary',
                        position: 'relative',
                      }}
                    >
                      {partner.testimonial}
                    </Typography>
                  </Box>

                  <Box sx={{
                    mt: 'auto',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <Box>
                      <Typography variant="h6"
                        sx={{ fontWeight: 600 }}>
                        {partner.name}
                      </Typography>
                      <Typography color="text.secondary"
                        variant="body2">
                        {partner.title}, {partner.company}
                      </Typography>
                    </Box>

                    {partner.metric && (
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        bgcolor: '#f5f5f7',
                        borderRadius: 2,
                        overflow: 'hidden'
                      }}>
                        <Typography
                          sx={{
                            px: 1.5,
                            py: 0.75,
                            fontWeight: 'bold'
                          }}
                        >
                          {partner.metric.value}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            px: 1.5,
                            py: 0.75,
                            color: 'common.white',
                            bgcolor: 'primary.main',
                            fontWeight: 500
                          }}
                        >
                          {partner.metric.label}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Container>
  </Box>
);
